module.exports = __webpack_public_path__ + "static/media/ecrire-message.f3953a3f.png";